import { useEffect, useState } from "react";
import { api, formatPrice } from "@/lib/api";
import { Badge } from "@/components/ui/badge";

const STATUS_STYLE = {
  pending_payment: "bg-yellow-500/10 text-yellow-400 border-yellow-500/30",
  forwarded_to_supplier: "bg-blue-500/10 text-blue-400 border-blue-500/30",
  shipped: "bg-purple-500/10 text-purple-400 border-purple-500/30",
  delivered: "bg-green-500/10 text-green-400 border-green-500/30",
  cancelled: "bg-red-500/10 text-red-400 border-red-500/30",
};
const STATUS_LABEL = {
  pending_payment: "PENDING PAYMENT",
  forwarded_to_supplier: "FORWARDED TO SUPPLIER",
  shipped: "SHIPPED",
  delivered: "DELIVERED",
  cancelled: "CANCELLED",
};

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/orders").then(({ data }) => setOrders(data.orders)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="container-tight py-8" data-testid="orders-page">
      <div className="mb-6">
        <div className="font-mono text-xs tracking-widest text-[#FF5C00] mb-1">// ACCOUNT</div>
        <h1 className="font-display font-black text-3xl md:text-4xl">MY ORDERS</h1>
      </div>
      {loading ? (
        <div className="font-mono text-zinc-500">LOADING...</div>
      ) : orders.length === 0 ? (
        <div className="text-center py-24 text-zinc-500 font-mono">NO ORDERS YET</div>
      ) : (
        <div className="space-y-4">
          {orders.map((o) => (
            <div key={o.id} data-testid={`order-${o.id}`} className="border border-zinc-800 bg-[#0a0a0c] rounded-sm overflow-hidden">
              <div className="flex flex-wrap items-center gap-4 px-4 py-3 bg-[#050505] border-b border-zinc-800">
                <div>
                  <div className="font-mono text-[10px] text-zinc-500 tracking-widest">ORDER</div>
                  <div className="font-mono text-xs text-white">{o.id.slice(0, 8).toUpperCase()}</div>
                </div>
                <div>
                  <div className="font-mono text-[10px] text-zinc-500 tracking-widest">PLACED</div>
                  <div className="font-mono text-xs text-white">{new Date(o.created_at).toLocaleDateString()}</div>
                </div>
                <div>
                  <div className="font-mono text-[10px] text-zinc-500 tracking-widest">TOTAL</div>
                  <div className="font-mono text-xs font-bold text-white">{formatPrice(o.total)}</div>
                </div>
                <div className="ml-auto">
                  <Badge variant="outline" className={`rounded-sm font-mono text-[10px] tracking-widest ${STATUS_STYLE[o.status] || ""}`}>
                    {STATUS_LABEL[o.status] || o.status}
                  </Badge>
                </div>
              </div>
              <div className="p-4 space-y-2">
                {o.items.map((it) => (
                  <div key={it.product_id} className="flex items-center gap-3 text-sm">
                    <img src={it.image} alt="" className="w-12 h-12 object-cover border border-zinc-800" />
                    <div className="flex-1 min-w-0">
                      <div className="text-white truncate">{it.name}</div>
                      <div className="font-mono text-xs text-zinc-500">×{it.quantity} · {formatPrice(it.price)}</div>
                    </div>
                    <div className="font-mono">{formatPrice(it.line_total)}</div>
                  </div>
                ))}
              </div>
              {o.supplier_info && (
                <div className="border-t border-zinc-800 px-4 py-3 bg-[#050505] font-mono text-xs text-zinc-500 flex flex-wrap gap-4">
                  <span>SUPPLIER: <span className="text-[#00F0FF]">{o.supplier_info.supplier}</span></span>
                  <span>REF: <span className="text-white">{o.supplier_info.supplier_order_id}</span></span>
                  {o.supplier_info.tracking_number && <span>TRACKING: <span className="text-white">{o.supplier_info.tracking_number}</span></span>}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
